<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row" style="margin-right: 0px;margin-left: 0px;">
            <div class="heading col-md-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: this.trainingTitle,
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Trainee`s Feedback',
                      active: true
                    }
                  ]
                    "
              ></vs-breadcrumb>
              <h3 class="text-secondary">Participant's Feedback</h3>
            </div>
          </div>
          <!-- <div class="col-sm-12 p-0 mb-4">
            <span style="font-weight:bold">
              Form Complete : 20%
              <vs-progress :percent="20" color="primary">primary</vs-progress>
            </span>
          </div>-->
          <!-- training title name section starts -->
          <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
              <label class="col-sm-1 font-weight-bold" style="color:#6c757d;">
                <h5>Title:</h5>
              </label>
              <div class="col-sm-11" style="color:#6c757d;">
                <h5 v-if="trainingTitle">{{trainingTitle}}</h5>
              </div>
            </div>
            <div class="row col-sm-12">
              <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">
                <h6>Start Date:</h6>
              </label>
              <h6
                class="col-sm-2"
                style="padding:0px 0px 0px 15px;color:#6c757d;"
                v-if="startDate"
              >{{startDate}}</h6>

              <label class="col-sm-2 font-weight-bold p-0">
                <h6>End Date:</h6>
              </label>
              <h6 class="col-sm-4 p-0" style="color:#6c757d;" v-if="endDate">{{endDate}}</h6>
            </div>
          </div>
          <!-- training title name section ends -->

          <!-- training question selection section starts -->
          <div class="row form-row text-dark" v-if="addTraineeFeedForm == true">
            <h6 class="sub-frm-title">Add Feedback questions</h6>
            <div class="col-sm-12"></div>
            <div class="col-sm-6 mt-2">
              <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                <b>Enter no. of question(s)</b>
                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
              </label>
              <!-- <p style="margin-bottom:0px;">
                <b>Enter no. of question(s)</b>
              </p>-->
              <div class="mt-2">
                <input
                  type="number"
                  style="height: 34px !important;"
                  v-model="no_of_question"
                  class="form-control"
                  placeholder="Enter no. of questions you want to add to trainee's feedback..."
                />
              </div>
            </div>
            <!-- filters starts -->
            <div class="col-sm-6 mt-2">
              <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                <b>Previous  Event</b>
                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
              </label>
              <!-- <p style="margin-bottom:0px;" class="mt-1">
                <b>Previous  Event</b>
              </p>-->
              <div class="mt-2">
                <selectize
                  id="select-state"
                  v-model="previoustrainingSelected"
                  :settings="previoustrainingSettings"
                >
                  <option
                    v-for="(item,index) in previousTrainingArr"
                    :key="index"
                    :value="item.id"
                  >{{item.title}}</option>
                </selectize>
              </div>
            </div>
            <div class="row w-100" style="margin-left:-8px">
              <!-- filters ends -->
              <!-- Repository Starts -->
              <div
                class="col-sm-6 mt-5"
                style="border: 1px dotted #07a7e14f; border-left:none;;"
                v-if="questionForm == true"
              >
                <div class="mb-3 repository-title">Repository</div>
                <div v-for="(item,index) in allQuestionsArr" v-bind:key="index">
                  <!-- questions Starts -->
                  <b-card class="mb-3">
                    <b-card-text>
                      <h6>
                        <strong>Q {{index+1}})</strong>
                        {{item[0].qtitle}}
                        <span></span>
                      </h6>
                    </b-card-text>
                    <div>
                      <b-badge
                        class="p-2 mr-1"
                        href="#"
                        variant="secondary"
                        v-if="item[0].qfrequency != null"
                      >F : {{item[0].qfrequency}}</b-badge>
                      <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                      <!-- Element to collapse -->
                      <b-collapse
                        :id="index+1"
                        class="mb-3"
                        v-for="(option, index2) in item[1]"
                        v-bind:key="index2"
                      >
                        <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                      </b-collapse>
                      <b-button
                        style="float:right;"
                        id="moveButton"
                        href="#"
                        @click="moveQuestion(index,item[0].qid)"
                        size="sm"
                        variant="primary"
                      >Add</b-button>
                    </div>
                  </b-card>
                  <!-- questions -->
                </div>
              </div>
              <!-- Repository Ends -->

              <!-- Selected questions Starts -->
              <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
                <div class="mb-3 ml-1 selected-title">Selected</div>
                <div v-if="selectedQuestionsArr.length > 0">
                  <!-- question selected Starts -->

                  <div
                    v-for="(item,index) in selectedQuestionsArr"
                    v-bind:key="index"
                    id="scrollToQuestion"
                  >
                    <!-- question Starts -->
                    <b-card class="mb-3">
                      <b-card-text>
                        <h6>
                          <strong>Q {{index+1}})</strong>
                          {{item[0].qtitle}}
                          <span></span>
                        </h6>
                      </b-card-text>
                      <div>
                        <b-badge
                          class="p-2 mr-1"
                          href="#"
                          variant="secondary"
                          v-if="item[0].qfrequency != null"
                        >F : {{item[0].qfrequency + 1}}</b-badge>
                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                        <!-- Element to collapse -->
                        <b-collapse
                          :id="index+1"
                          class="mb-3"
                          v-for="(option, index2) in item[1]"
                          v-bind:key="index2"
                        >
                          <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                        </b-collapse>
                        <b-button
                          style="float:right;"
                          href="#"
                          size="sm"
                          @click="removeQuestion(index)"
                          variant="danger"
                        >Remove</b-button>
                      </div>
                    </b-card>
                    <!-- question Ends -->
                  </div>
                  <div class="mb-5">
                    <b-button
                      id="mybutton"
                      @click="submitForm()"
                      variant="primary"
                      style="float:right;"
                      size="sm"
                    >Submit</b-button>
                  </div>
                </div>
              </div>
              <!-- Selected questions Ends -->
            </div>
          </div>
          <div v-else-if="existTraineeFeedForm == true">
            <h6 class="sub-frm-title">Trainee Feedback has been created for this training</h6>
            <!-- table starts -->
            <b-card class="mt-3">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-12 p-0">
                    <div class="table-responsive">
                      <div class="mb-1" style="float:right">
                        <b-button variant="outline-primary" class="mr-1" size="sm">Edit</b-button>
                        <b-button variant="outline-danger" class="mr-1" size="sm">Delete</b-button>
                      </div>
                      <table class="table">
                        <tr>
                          <th>Sr#</th>
                          <th>Question</th>
                          <th>Added at</th>
                        </tr>
                        <tr v-for="(item,index) in traineeFeedbackShowArr" v-bind:key="index">
                          <td>{{index+1}}</td>
                          <td>{{item.question.title}}</td>
                          <td>{{item.createdAt | formatDate}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>

          <!-- training question selection section ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import Selectize from "vue2-selectize";

import axios from "axios";
export default {
  data: () => ({
    trainingId: "",
    trainingCode: "",
    trainingTitle: "",
    startDate: "",
    endDate: "",
    no_of_question: "",
    allQuestionsArr: [],
    filteredQuestionsArr: [],
    selectedQuestionsArr: [],

    currentx: 1,
    currentx2: 1,
    radios1: "",
    value1: [0, 50],
    isSidebar: false,
    questionForm: true,
    filterForm: false,
    addTraineeFeedForm: true,
    existTraineeFeedForm: false,
    previousTrainingArr: [],
    previoustrainingSelected: "",
    previoustrainingSettings: {
      maxItems: 4,
      plugins: ["remove_button"]
    },
    traineeFeedbackShowArr: []
  }),
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.training.id;
        this.currentTraining();
        this.showPreviousTrainings();
        this.allQuestions();
        this.isExistTraineeFeed();
        this.showTraineeFeedback();
      });
    
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 2000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 2000,
        variant: "danger",
        solid: true
      });
    },
    // this will reset form elements
    resetFormElements: function resetFormElements() {
      this.previoustrainingSelected = "";
    },
    // this will check if Trainee feedback already created or not
    isExistTraineeFeed: function isExistTraineeFeed() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainee-feedback/" +
            this.trainingId +
            "/check/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success != "" && response.data.success != null) {
            this.addTraineeFeedForm = false;
            this.existTraineeFeedForm = true;
          } else {
            this.addTraineeFeedForm = true;
            this.existTraineeFeedForm = false;
          }
        });
    },
    // this will show trainer feedback which has been added
    showTraineeFeedback: function showTraineeFeedback() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/program-officer/training/trainee-feedback/" +
            this.trainingId +
            "/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.traineeFeedbackShowArr = response.data;
        });
    },
    // this will show current training of a program officer
    currentTraining: function currentTraining() {
      let userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/current-training/" +
            this.trainingId +
            "/" +
            userId.id +
            "/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingTitle = response.data.title;
          this.startDate = response.data.startdate;
          this.endDate = response.data.enddate;
        });
    },
    // this will show all questions
    allQuestions: function allQuestions() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/all-questions/trainee-feedback/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allQuestionsArr = response.data;
        });
    },
    // this will show selected questions
    async moveQuestion(val, qid) {
      if (this.no_of_question != "" && this.no_of_question != 0) {
        if (this.selectedQuestionsArr.length + 1 > this.no_of_question) {
          this.$toasted.global.errorMsg("Selected questions queue is full.");
          return false;
        } else {
          let checkValue = this.selectedQuestionsArr.some(function(value) {
            return value[0].qid == qid;
          });

          if (checkValue == true) {
            this.$toasted.global.errorMsg("Question was already moved.");
          } else {
            // this.moveScrollTo();
            this.$toasted.global.successMsg("Question moved successfully!");
            this.selectedQuestionsArr.push(this.allQuestionsArr[val]);
            this.allQuestionsArr.splice(val, 1);
          }
        }
      } else {
        this.$toasted.global.errorMsg("Enter no of questions you want to select.");
      }
    },
    // this will remove questions from selected queue
    removeQuestion(val) {
      this.allQuestionsArr.push(this.selectedQuestionsArr[val]);
      this.selectedQuestionsArr.splice(val, 1);
      this.$toasted.global.errorMsg("Question removed from selected!");
    },
    // This will submit trainee feedbackform
    submitForm() {
      if (this.no_of_question != this.selectedQuestionsArr.length) {
        this.$toasted.global.errorMsg(
          "Please check that no. of question is equal to selected question."
        );
      } else {
        let userId = JSON.parse(localStorage.getItem("currentUser"));
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/admin/training/trainee-feedback/add",
            {
              saveSelected: this.selectedQuestionsArr,
              training_id: this.trainingId,
              user_id: userId.id
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              // empty all varaibles
              this.allQuestionsArr = [];
              this.selectedQuestionsArr = [];
              this.questionForm = true;
              this.filterForm = false;
              this.addTraineeFeedForm = false;
              this.existTraineeFeedForm = true;
              // End empty all varaibles
              this.$toasted.global.successMsg(
                "Trainee Feedback has been created successfully."
              );
            } else {
              this.$toasted.global.errorMsg(
                "Error: Something went wrong while creating Trainee Feedback."
              );
            }
          });
      }
    },
    showPreviousTrainings: function showPreviousTrainings() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/previous-trainings/" +
            this.trainingId +
            "/trainer-feedback/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.previousTrainingArr = response.data;
        });
    }
  },
  // methods END now

  watch: {
    no_of_question() {
      if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question < this.selectedQuestionsArr.length
      ) {
        this.$toasted.global.errorMsg(
          "No. of questions in input, decreased from selected questions in queue."
        );
      } else if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question == this.selectedQuestionsArr.length
      ) {
        return true;
      } else if (this.no_of_question == 0) {
        this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
      } else {
        this.$toasted.global.successMsg("Now you can move questions.");
      }
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.b-list-group-item.opt-list-item {
  border: none !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.level-radios ul li {
  padding: 3px;
}
.p-2 {
  padding: 12px !important;
}
.repository-title {
  width: 142px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.selected-title {
  width: 115px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.crd-title {
  font-size: 20px;
}
</style>
<style >
.vs-slider {
  background-color: #c9ddff !important;
}
.con-content--item {
  padding: 0px !important;
}
</style>
